import camelCase from 'lodash/camelCase';
import React, { useState } from 'react';
import { Button, Icon, PriceString } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import * as S from './styled';
export const Incentive = ({ type, icon, label, bonus, button, isCompleted }) => {
    const [isHovered, setIsHovered] = useState(false);
    const formattedId = camelCase(type);
    return (React.createElement(S.Container, { id: formattedId, completed: isCompleted, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) },
        React.createElement(S.Icon, null, icon),
        React.createElement(S.Title, null, label),
        !isCompleted && bonus && (React.createElement(S.Award, null,
            "+",
            React.createElement(PriceString, { value: bonus.value, currency: bonus.currency }))),
        isCompleted && bonus && (React.createElement(S.ButtonContainer, null,
            React.createElement(S.Completed, null,
                React.createElement(Icon, { component: TickIcon, height: 14, width: 14 }),
                "Earned ",
                React.createElement(PriceString, { value: bonus.value, currency: bonus.currency })))),
        !isCompleted && button && (React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { ...button, label: button.label, appearance: isHovered && !isCompleted ? 'primary' : 'secondary', size: "xsmall", "data-analytics": formattedId })))));
};
